module.exports = "https://cdn.redage.net/src/views/games/other/images/maps/tanks1.png";